<div class="rfr_input-wrapper">
  <ion-item lines="none" [style]="style" [class]="class" [ngClass]="{
      'rfr_ion-item': !readonly,
      'rfr_ion-item_read-only': readonly,
      'rfr_ion-item_error': !readonly && required && ((error || (controlDir?.errors && this.controlDir?.control?.touched))),
      'rfr-size-normal': size === 'normal',
      'rfr-size-large': size === 'large',
    }">
    <div style="margin-right: 5px;">
      <ng-content select="icon-start"></ng-content>
    </div>

    <ion-input
      [ngClass]="{
          'rfr_input': true,
          'rfr_input_text-left': alignInputText === 'left',
          'rfr_input_text-right': alignInputText === 'right',
          'rfr_input_text-center': alignInputText === 'center',
          }"
      labelPlacement="floating"
      [type]="type"
      [id]="id"
      #inputLocationElement
      [value]="controlDir?.control?.value"
      (input)="onChangeInput($any($event.target).value)"
      [disabled]="disabled"
      [readonly]="readonly"
      [placeholder]="placeholder"
      [pattern]="pattern"
      [min]="min"
      [max]="max"
      [maxlength]="maxLength"
    >
      <div class="rfr-label-text" slot="label">
        {{ labelText }} <ion-text color="danger" *ngIf="required">*</ion-text>
      </div>
    </ion-input>
    <ng-content select=".slot-end"></ng-content>
  </ion-item>
  <ng-content select="[slot=error-message]"></ng-content>
</div>
